/** Convierte gramos de balanza → cantidad de carrito según UoM del producto. */
export function gramsToCartQuantity(grams: number, unitOfMeasure: string | null | undefined): number | null {
  if (!Number.isFinite(grams) || grams <= 0) return null;
  const uom = (unitOfMeasure ?? 'kg').toLowerCase();
  if (uom === 'g') return Math.round(grams * 1000) / 1000;
  if (uom === 'kg') return Math.round((grams / 1000) * 1000) / 1000;
  return null;
}

export function formatGramsAsCartInput(grams: number, unitOfMeasure: string | null | undefined): string {
  const qty = gramsToCartQuantity(grams, unitOfMeasure);
  if (qty == null) return '';
  return String(qty).replace('.', ',');
}
